<div class="col no-overflow padding all page-width">
  <div class="row no-overflow page-width">
    <mat-card class="no-overflow fill padding all">
      <mat-card-header>
        <mat-card-title-group>
          <mat-card-title>Registry Numbers</mat-card-title>
        </mat-card-title-group>
        <button mat-icon-button class="marginleft">
          <mat-icon>edit</mat-icon>
        </button>
      </mat-card-header>
      <div class="table-body">
        <table mat-table [dataSource]="dataSource">
          <!-- Key Symbol -->
          <ng-container matColumnDef="keySymbol">
            <th mat-header-cell *matHeaderCellDef>Key Symbol</th>
            <td mat-cell *matCellDef="let element">
              {{ element.keySetSymbol }}
            </td>
          </ng-container>

          <!-- Registry Number Column -->
          <ng-container matColumnDef="registryNumber">
            <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Name">Registry Number</th>
            <td mat-cell *matCellDef="let element">
              {{ element.registerNumber }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
      <mat-divider></mat-divider>
      <mat-paginator
        class="paginator-wrapper"
        #paginator
        [pageSizeOptions]="[10, 25, 100, 200]"
        [pageSize]="25"
        showFirstLastButtons
        aria-label="RegistryNumbers"
      >
      </mat-paginator>
    </mat-card>
  </div>
</div>
